import React from "react";
import PropTypes from "prop-types";
import { Divider } from "@qgiv/core-donor";

const ReceiptDonation = ({ amount, restriction = "", donationLabel = "" }) => (
    <>
        <div className="col col--12 col--no-top-gutter">
            <div className="grid">
                <div className="col col--8">
                    <p>
                        {donationLabel}
                        {restriction && (
                            <>
                                <br />
                                {restriction}
                            </>
                        )}
                    </p>
                </div>
                <div className="col col--4 -text--right">{amount}</div>
            </div>
        </div>
        <Divider dashed />
    </>
);

ReceiptDonation.propTypes = {
    amount: PropTypes.string.isRequired,
    restriction: PropTypes.string,
    donationLabel: PropTypes.string,
};

export default ReceiptDonation;
